import React from 'react';
import {  Grid } from '@mui/material';
import BadgeEmbed from './BadgeEmbed';

const badgeIds = [
    '5d2c36d4-59fd-4c74-b107-cc7573c6de31',
    'b0535ab3-cc9a-4bad-a9e1-718f5d8b2c39',
    '0765e5ea-293d-4224-b5e1-55bdf27066ff'
  ];



const Certifications  =  () => {
    return (
        <Grid container spacing={4}>
          {badgeIds.map((id) => (
            <Grid item key={id}>
              <BadgeEmbed badgeId={id} />
            </Grid>
          ))}
        </Grid>
      );
}

export default Certifications;